import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = ["onClick"];
import { TUITranslateService, TUIStore, StoreName, TUIChatService } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../../adapter-vue";
import ToolbarItemContainer from "../toolbar-item-container/index.vue";
import wordsIcon from "../../../../assets/icon/words.svg";
import { wordsList } from "../../utils/wordsList";
import { isEnabledMessageReadReceiptGlobal } from "../../utils/utils";
import { isPC, isUniFrameWork } from "../../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var _currentConversation = ref();
    var container = ref();
    TUIStore.watch(StoreName.CONV, {
      currentConversation: function currentConversation(conversation) {
        _currentConversation.value = conversation;
      }
    });
    var selectWord = function selectWord(item) {
      var _currentConversation$, _currentConversation$2, _currentConversation$3, _container$value;
      var options = {
        to: (_currentConversation === null || _currentConversation === void 0 || (_currentConversation$ = _currentConversation.value) === null || _currentConversation$ === void 0 || (_currentConversation$ = _currentConversation$.groupProfile) === null || _currentConversation$ === void 0 ? void 0 : _currentConversation$.groupID) || (_currentConversation === null || _currentConversation === void 0 || (_currentConversation$2 = _currentConversation.value) === null || _currentConversation$2 === void 0 || (_currentConversation$2 = _currentConversation$2.userProfile) === null || _currentConversation$2 === void 0 ? void 0 : _currentConversation$2.userID),
        conversationType: _currentConversation === null || _currentConversation === void 0 || (_currentConversation$3 = _currentConversation.value) === null || _currentConversation$3 === void 0 ? void 0 : _currentConversation$3.type,
        payload: {
          text: TUITranslateService.t("Words.".concat(item.value))
        },
        needReadReceipt: isEnabledMessageReadReceiptGlobal()
      };
      TUIChatService.sendTextMessage(options);
      // 提交后关闭 dialog
      // close dialog after submit evaluate
      container === null || container === void 0 || (_container$value = container.value) === null || _container$value === void 0 || _container$value.toggleDialogDisplay(false);
    };
    var closeDialog = function closeDialog() {
      var _container$value2;
      container === null || container === void 0 || (_container$value2 = container.value) === null || _container$value2 === void 0 || _container$value2.toggleDialogDisplay(false);
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(ToolbarItemContainer, {
        iconFile: _unref(wordsIcon),
        title: "常用语",
        needBottomPopup: true,
        iconWidth: _unref(isUniFrameWork) ? '26px' : '20px',
        iconHeight: _unref(isUniFrameWork) ? '26px' : '20px',
        ref_key: "container",
        ref: container
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", {
            "class": _normalizeClass(['words', !_unref(isPC) && 'words-h5'])
          }, [_createElementVNode("div", {
            "class": _normalizeClass(['words-header', !_unref(isPC) && 'words-h5-header'])
          }, [_createElementVNode("span", {
            "class": _normalizeClass(['words-header-title', !_unref(isPC) && 'words-h5-header-title'])
          }, _toDisplayString(_unref(TUITranslateService).t("Words.常用语-快捷回复工具")), 3), !_unref(isPC) ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            "class": _normalizeClass(['words-header-close', !_unref(isPC) && 'words-h5-header-close']),
            onClick: closeDialog
          }, " 关闭 ", 2)) : _createCommentVNode("", true)], 2), _createElementVNode("ul", {
            "class": _normalizeClass(['words-list', !_unref(isPC) && 'words-h5-list'])
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wordsList), function (item, index) {
            return _openBlock(), _createElementBlock("li", {
              "class": _normalizeClass(['words-list-item', !_unref(isPC) && 'words-h5-list-item']),
              key: index,
              onClick: function onClick($event) {
                return selectWord(item);
              }
            }, _toDisplayString(_unref(TUITranslateService).t("Words.".concat(item.value))), 11, _hoisted_1);
          }), 128))], 2)], 2)];
        }),
        _: 1
      }, 8, ["iconFile", "iconWidth", "iconHeight"]);
    };
  }
});